import * as React from 'react';
import styled from 'styled-components';

const Figure = styled.figure`
	padding: 1em 0;
	text-align: center;

	& img {
		margin: 0 2em 2em;
		max-width: 140px;

		@media (${(props) => props.theme.mediumUp}) {
			margin: 0 2em 2em;
			max-width: 170px;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 200px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 230px;
		}
	}
`;

const PortraitNameTitle = ({jpg, name, jobTitle, url}) => (
	<Figure>
		{url ? (
			<>
				<a href={url} title='employee spotlight' target='_blank'>
					<img
						src={jpg}
						alt={name}
					/>
				</a>
				<h3 className='name'>{name}</h3>
				<h4 className='job-title'>{jobTitle}</h4>
			</>
		) : (
			<>
				<img
					src={jpg}
					alt={name}
				/>
				<h3 className='name'>{name}</h3>
				<h4 className='job-title'>{jobTitle}</h4>
			</>
		)}
	</Figure>
);

export default PortraitNameTitle;
